"use client";

import { useEffect, useRef, useState } from "react";

const statements = [
  { label: "Communities" },
  { label: "Partnerships" },
  { label: "Creator Programs" },
  { label: "3D Reconstructions" },
  { label: "Events" },
  { label: "Social Channels" },
  { label: "Support Systems" },
  { label: "Product Launches" },
  { label: "Open-Source Tools" },
];

export function RotatingIntro() {
  const [activeStatement, setActiveStatement] = useState(0);
  const [isAnimationActive, setIsAnimationActive] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const active = statements[activeStatement];

  useEffect(() => {
    const root = rootRef.current;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!root || reduceMotion) return;

    let isInViewport = false;
    let isDocumentVisible = document.visibilityState === "visible";
    const sync = () => setIsAnimationActive(isInViewport && isDocumentVisible);
    const observer = new IntersectionObserver(([entry]) => {
      isInViewport = entry?.isIntersecting ?? false;
      sync();
    }, { rootMargin: "80px 0px", threshold: 0 });
    const handleVisibilityChange = () => {
      isDocumentVisible = document.visibilityState === "visible";
      sync();
    };

    observer.observe(root);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (!isAnimationActive) return;
    const interval = window.setInterval(() => {
      setActiveStatement((current) => (current + 1) % statements.length);
    }, 2600);
    return () => window.clearInterval(interval);
  }, [isAnimationActive]);

  return (
    <div className="rotating-intro" ref={rootRef}>
      <p className="rotating-intro-visual">
        <span className="rotating-intro-prefix">I build</span>
        <span className="rotating-intro-slot">
          <span className="rotating-intro-word" key={active.label}>{active.label}</span>
        </span>
      </p>
      <p className="sr-only">
        I build communities, partnerships, creator programs, 3D reconstructions, events,
        social channels, support systems, product launches, and open-source tools.
      </p>
    </div>
  );
}
